export default __webpack_public_path__ + "static/media/shirt5.c1f032c5.jpeg";